import React from 'react'
import TitlePopUp from '@/components/TitlePopUp'
import { Dialog, DialogContent, DialogTitle } from '@mui/material'

import ImportCentresPaymentsContent from './ImportCentresPaymentsContent'

const PopUpImportCentresPayments = ({ openPopUp, setOpenPopUp }) => {
  const handleClosePopUp = () => {
    setOpenPopUp(false)
  }

  return (
    <div>
      <Dialog
        disableEscapeKeyDown={true}
        maxWidth="md"
        fullWidth
        open={openPopUp}
        onClose={handleClosePopUp}
        scroll="paper"
      >
        <DialogTitle style={{ padding: '0px' }}>
          <TitlePopUp textTitle={'Importar montos de suscripción'} handleClose={handleClosePopUp} />
        </DialogTitle>
        <DialogContent style={{ padding: '0px' }}>
          <ImportCentresPaymentsContent handleClosePopUp={handleClosePopUp} />
        </DialogContent>
      </Dialog>
    </div>
  )
}

export default PopUpImportCentresPayments
